module.exports = __webpack_public_path__ + "static/media/logo-apps.ae687bec.png";